module.exports = __webpack_public_path__ + "img/ni.704a21bf.svg";